export const vendorPreserve = [
  "vendorCompanyName",
  "vendorCompanyID",
  "vendorEmail",
  "vendorCompanyAddress",
  "vendorCompanyStreet",
  "vendorCompanyStreetNumber",
  "vendorCompanyLocality",
  "vendorCompanyRegion",
  "vendorCompanyZipCode",
  "vendorCountry",
];

export const customerPreserve = [
  "customerCompanyName",
  "customerCompanyID",
  "customerEmail",
  "customerCompanyAddress",
  "customerCompanyStreet",
  "customerCompanyStreetNumber",
  "customerCompanyLocality",
  "customerCompanyRegion",
  "customerCompanyZipCode",
  "customerCountry",
  "logoURL",
];
